import React, { useState } from 'react';
import {
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Card,
  CardContent,
  Grid,
  Chip,
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  Help as HelpIcon,
  Dashboard as DashboardIcon,
  Inventory as InventoryIcon,
  SwapHoriz as SwapHorizIcon,
  People as PeopleIcon,
  PointOfSale as PointOfSaleIcon,
  Person as PersonIcon,
  Login as LoginIcon,
  Warning as WarningIcon,
  CheckCircle as CheckIcon,
} from '@mui/icons-material';

function Ayuda() {
  const [expanded, setExpanded] = useState('panel1');

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const secciones = [
    {
      id: 'panel1',
      titulo: 'Inicio de Sesión',
      icono: <LoginIcon sx={{ color: '#1976d2' }} />,
      contenido: [
        'Ingrese su correo electrónico y contraseña en la pantalla de login.',
        'Si olvidó su contraseña, haga clic en "¿Olvidaste tu contraseña?" y contacte al administrador.',
        'Por seguridad, el sistema cerrará su sesión automáticamente si el token expira.',
      ]
    },
    {
      id: 'panel2',
      titulo: 'Dashboard - Inteligencia de Negocios',
      icono: <DashboardIcon sx={{ color: '#1976d2' }} />,
      contenido: [
        'El Dashboard muestra métricas clave del negocio en tiempo real.',
        'KPIs principales: Total de productos, clientes, valor de inventario, ventas del mes, cotizaciones pendientes y alertas de stock.',
        'Gráficos disponibles: Ventas mensuales (línea), métodos de pago (doughnut), productos más vendidos (barras horizontales) y stock por categoría (barras verticales).',
        'Las alertas de stock bajo se muestran en rojo para una rápida identificación.',
      ]
    },
    {
      id: 'panel3',
      titulo: 'Gestión de Productos',
      icono: <InventoryIcon sx={{ color: '#388e3c' }} />,
      contenido: [
        'Use "Nuevo Producto" para registrar un producto en el inventario.',
        'Complete todos los campos obligatorios: código, nombre, categoría, precio de compra y venta.',
        'El campo "Stock Actual" indica las unidades disponibles en almacén.',
        'Use los filtros para buscar por nombre, categoría o estado de stock.',
        'Exporte la lista a PDF o Excel usando los botones superiores.',
        'Los productos con stock menor o igual al mínimo se marcarán en rojo automáticamente.',
      ]
    },
    {
      id: 'panel4',
      titulo: 'Kardex Digital',
      icono: <SwapHorizIcon sx={{ color: '#f57c00' }} />,
      contenido: [
        'El Kardex registra todos los movimientos de entrada y salida de inventario.',
        'Para registrar una ENTRADA (compra): haga clic en "Registrar Entrada", seleccione el producto, cantidad, precio y motivo.',
        'Para registrar una SALIDA (venta): haga clic en "Registrar Salida", complete los datos. El sistema validará que haya stock suficiente.',
        'Cada movimiento actualiza automáticamente el stock del producto.',
        'El historial muestra: stock anterior, cantidad movida y stock nuevo.',
      ]
    },
    {
      id: 'panel5',
      titulo: 'Gestión de Clientes',
      icono: <PeopleIcon sx={{ color: '#7b1fa2' }} />,
      contenido: [
        'Registre clientes individuales, empresas o instituciones.',
        'Complete el tipo y número de documento (DNI, RUC, etc.).',
        'Use los filtros para buscar por nombre, documento o tipo de cliente.',
        'Exporte la lista completa a PDF o Excel.',
      ]
    },
    {
      id: 'panel6',
      titulo: 'Ciclo de Ventas',
      icono: <PointOfSaleIcon sx={{ color: '#d32f2f' }} />,
      contenido: [
        'El ciclo de ventas tiene 4 etapas: Cotización → Pedido → Factura → Entrega.',
        '1. COTIZACIÓN: Cree una cotización seleccionando el cliente y productos. El sistema calcula automáticamente subtotal, IGV (18%) y total.',
        '2. PEDIDO: Convierta una cotización aprobada en pedido. El pedido confirma la intención de compra.',
        '3. FACTURA: Emita una factura desde un pedido. Seleccione el método de pago (efectivo, transferencia, tarjeta, Yape, Plin).',
        '4. ENTREGA: Programe la entrega desde una factura pagada. Indique fecha, dirección y responsable.',
        'Use las pestañas para navegar entre cada etapa. Los botones de conversión aparecen según el estado del documento.',
      ]
    },
    {
      id: 'panel7',
      titulo: 'Mi Perfil',
      icono: <PersonIcon sx={{ color: '#1976d2' }} />,
      contenido: [
        'Visualice y edite su información personal (nombre y email).',
        'Cambie su contraseña usando el botón "Cambiar Contraseña".',
        'Debe ingresar la contraseña actual para poder crear una nueva.',
        'La nueva contraseña debe tener al menos 6 caracteres.',
      ]
    },
  ];

  const faqs = [
   
    {
      pregunta: '¿Cómo sé si un producto tiene stock bajo?',
      respuesta: 'En la lista de productos, el stock aparece en rojo cuando es igual o menor al stock mínimo. También puede ver las alertas en el Dashboard.'
    },
    {
      pregunta: '¿Puedo eliminar un producto?',
      respuesta: 'Sí, pero el sistema realiza una eliminación lógica (cambia el estado a "inactivo"). El producto seguirá en la base de datos para mantener el historial del Kardex.'
    },
    {
      pregunta: '¿Qué pasa si intento registrar una salida sin stock suficiente?',
      respuesta: 'El sistema mostrará un error indicando "Stock insuficiente" y no permitirá registrar la salida hasta que haya suficientes unidades disponibles.'
    },
    {
      pregunta: '¿Cómo convierto una cotización en pedido?',
      respuesta: 'Vaya a Ventas → Cotizaciones. Busque la cotización con estado "Pendiente" y haga clic en el botón verde "A Pedido". Complete los datos y confirme.'
    },
    {
      pregunta: '¿Puedo exportar los reportes?',
      respuesta: 'Sí. En las páginas de Productos, Kardex, Clientes y Ventas encontrará botones "PDF" y "Excel" para descargar los reportes correspondientes.'
    },
  ];

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 'bold' }}>
        Manual de Usuario - Ayuda
      </Typography>

      {/* Introducción */}
      <Paper sx={{ p: 3, mb: 3, backgroundColor: '#e3f2fd' }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 1 }}>
          👋 Bienvenido al Sistema EJARAD-TIC
        </Typography>
        <Typography variant="body1">
          Este manual le guiará en el uso del sistema integral de gestión comercial. 
          Si tiene alguna duda adicional, contacte al soporte técnico.
        </Typography>
      </Paper>

      {/* Guía por módulos */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
            📚 Guía por Módulos
          </Typography>
          {secciones.map((seccion) => (
            <Accordion
              key={seccion.id}
              expanded={expanded === seccion.id}
              onChange={handleChange(seccion.id)}
              sx={{ mb: 1 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {seccion.icono}
                  <Typography sx={{ fontWeight: 'bold' }}>{seccion.titulo}</Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <List dense>
                  {seccion.contenido.map((item, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <CheckIcon sx={{ color: '#388e3c', fontSize: 20 }} />
                      </ListItemIcon>
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </List>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>

        {/* FAQs y Contacto */}
        <Grid item xs={12} md={4}>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold' }}>
            ❓ Preguntas Frecuentes
          </Typography>
          {faqs.map((faq, index) => (
            <Card key={index} sx={{ mb: 2 }}>
              <CardContent>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 1 }}>
                  <HelpIcon sx={{ fontSize: 18, mr: 0.5, verticalAlign: 'middle' }} />
                  {faq.pregunta}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {faq.respuesta}
                </Typography>
              </CardContent>
            </Card>
          ))}

          <Divider sx={{ my: 3 }} />

          <Paper sx={{ p: 3, backgroundColor: '#fff3e0' }}>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#f57c00', mb: 2 }}>
              📞 Contacto de Soporte
            </Typography>
            <Typography variant="body2" paragraph>
              <strong>Empresa:</strong> EJARAD-TIC Soluciones Informáticas
            </Typography>
            <Typography variant="body2" paragraph>
              <strong>Ubicación:</strong> Piura, Perú
            </Typography>
            <Typography variant="body2" paragraph>
              <strong>Email:</strong> soporte@ejarad-tic.com
            </Typography>
            <Typography variant="body2" paragraph>
              <strong>Teléfono:</strong> 073-123456
            </Typography>
            <Typography variant="body2" paragraph>
              <strong>Horario:</strong> Lunes a Viernes, 8:00 am - 6:00 pm
            </Typography>
            <Chip 
              label="Sistema v1.0.0 | 2026" 
              color="primary" 
              size="small" 
              sx={{ mt: 1 }}
            />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Ayuda;